export const SEGMENTS_GET_LIST = "markets/GET_LIST";
export const SEGMENTS_GET_DATA = "markets/GET_DATA";
export const SEGMENTS_GET_NOTABLE_OPERATORS = "markets/GET_NOTABLE_OPERATORS";
export const SEGMENTS_GET_NOTABLE_OPERATORS_TABS = "markets/GET_NOTABLE_OPERATORS_TABS";